import { render, staticRenderFns } from "./molecule.tileselect.vue?vue&type=template&id=3dce243f"
import script from "./molecule.tileselect.vue?vue&type=script&lang=ts"
export * from "./molecule.tileselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports